import { MainFilterInterface } from 'modules/main/types/main-filter-interface'

type MainDateFilter = { [Key in keyof MainFilterInterface]: string }

export const hasMainFilterDates = (filter: MainFilterInterface): filter is MainDateFilter =>
  filter.dateSince !== null && filter.dateTill !== null

export const getMainFilterQuery = ({ dateSince, dateTill }: MainDateFilter) =>
  `filter[dateSince]=${dateSince}&filter[dateTill]=${dateTill}`
